import { render, staticRenderFns } from "./NewsListView.vue?vue&type=template&id=265ba48f&scoped=true&"
import script from "./NewsListView.vue?vue&type=script&lang=js&"
export * from "./NewsListView.vue?vue&type=script&lang=js&"
import style0 from "./NewsListView.vue?vue&type=style&index=0&id=265ba48f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265ba48f",
  null
  
)

export default component.exports